export default "__VITE_ASSET__DBOvT0rn__"